module.exports = __webpack_public_path__ + "img/pic16.c4215ac0.jpg";